module.exports = __webpack_public_path__ + "static/media/dwg.42590fd1.svg";